function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "diamond");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.885 15.116l-14.001-14c-0.226-0.226-0.539-0.366-0.884-0.366s-0.658 0.14-0.884 0.366l-14 14c-0.226 0.226-0.366 0.539-0.366 0.884s0.14 0.658 0.366 0.884l14 14.001c0.226 0.226 0.539 0.365 0.884 0.365s0.657-0.14 0.884-0.365l14.001-14.001c0.225-0.227 0.365-0.539 0.365-0.884s-0.139-0.657-0.365-0.884l0 0zM16 28.232l-12.232-12.232 12.232-12.232 12.232 12.232z"
});

var SvgDiamond = function SvgDiamond(props) {
  return React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/diamond.471bb522.svg";
export { SvgDiamond as ReactComponent };